import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuGitega'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const karusiData = {
  title: "RÉPARTITION DE LA POPULATION DE LA COMMUNE DE KARUSI PAR ZONE ET COLLINE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "106",
      name: "KARUSI",
      total: 376731,
      zones: [
        {
          id: "10601",
          name: "PARK NATIONAL *",
          total: 1,
          collines: [
            { id: "10601101", name: "PARK NATIONAL DE LA RUVUBU", population: 1 }
          ]
        },
        {
          id: "10602",
          name: "BUGENYUZI",
          total: 44143,
          collines: [
            { id: "10602101", name: "BUGENYUZI", population: 8719 },
            { id: "10602102", name: "KANAZI", population: 5696 },
            { id: "10602103", name: "KIRANDA", population: 5707 },
            { id: "10602104", name: "KIGUFI", population: 4156 },
            { id: "10602105", name: "MUYANGE", population: 4379 },
            { id: "10602106", name: "CANZIKIRO", population: 4042 },
            { id: "10602107", name: "CUBA", population: 3628 },
            { id: "10602108", name: "MURAMBA", population: 3491 },
            { id: "10602109", name: "GASHANGA", population: 2762 },
            { id: "10602110", name: "NYAGOBA", population: 1563 }
          ]
        },
        {
          id: "10603",
          name: "BUHIGA",
          total: 29718,
          collines: [
            { id: "10603101", name: "BUHIGA", population: 7676 },
            { id: "10603102", name: "RWINGOMA", population: 2842 },
            { id: "10603103", name: "RAMVYA", population: 2472 },
            { id: "10603104", name: "RUVUMU", population: 2570 },
            { id: "10603105", name: "KARUNYINYA", population: 2464 },
            { id: "10603106", name: "MWOYA", population: 4812 },
            { id: "10603107", name: "GITANGA", population: 2418 },
            { id: "10603108", name: "MAGAMBA", population: 2122 },
            { id: "10603109", name: "NZIBARIBA", population: 2342 }
          ]
        },
        {
          id: "10604",
          name: "BUHINDYE",
          total: 27998,
          collines: [
            { id: "10604101", name: "RWANDAGARO", population: 5167 },
            { id: "10604102", name: "BUHINDYE", population: 5686 },
            { id: "10604103", name: "NYAMIRAMBO", population: 4250 },
            { id: "10604104", name: "KIDAHWE", population: 4429 },
            { id: "10604105", name: "TEME", population: 5332 },
            { id: "10604106", name: "GISHIKANWA", population: 3134 }
          ]
        },
        {
          id: "10605",
          name: "BUHINYUZA",
          total: 20560,
          collines: [
            { id: "10605101", name: "BUHINYUZA", population: 3919 },
            { id: "10605102", name: "KANYANGE", population: 4034 },
            { id: "10605103", name: "RUTEGAMA", population: 3530 },
            { id: "10605104", name: "BUSHIRAMBEHO", population: 3383 },
            { id: "10605105", name: "NKORONKO", population: 3109 },
            { id: "10605106", name: "GISENYI", population: 2585 }
          ]
        },
        {
          id: "10606",
          name: "CIRAMBO",
          total: 19827,
          collines: [
            { id: "10606101", name: "CIRAMBO", population: 4692 },
            { id: "10606102", name: "RUSAGARA", population: 3978 },
            { id: "10606103", name: "RWIZINGWE", population: 3155 },
            { id: "10606104", name: "KINYOTA", population: 3247 },
            { id: "10606105", name: "MARAMVYA", population: 2146 },
            { id: "10606106", name: "KIYANGE", population: 2609 }
          ]
        },
        {
          id: "10607",
          name: "GISIMBAWAGA",
          total: 21811,
          collines: [
            { id: "10607101", name: "MUTARA", population: 6041 },
            { id: "10607102", name: "KIBUYE", population: 4673 },
            { id: "10607103", name: "GASERA", population: 4326 },
            { id: "10607104", name: "BUTAHA", population: 3907 },
            { id: "10607105", name: "GISIMBAWAGA", population: 2864 }
          ]
        },
        {
          id: "10608",
          name: "GITARAMUKA",
          total: 25836,
          collines: [
            { id: "10608101", name: "GITARAMUKA", population: 6258 },
            { id: "10608102", name: "KAGWA", population: 5270 },
            { id: "10608103", name: "KIBENGA", population: 3953 },
            { id: "10608104", name: "RUBUGA", population: 4084 },
            { id: "10608105", name: "GASASA", population: 3664 },
            { id: "10608106", name: "NYARUTOVU", population: 2607 }
          ]
        },
        {
          id: "10609",
          name: "KIBUMBWE",
          total: 23077,
          collines: [
            { id: "10609101", name: "MUVUMU", population: 4854 },
            { id: "10609102", name: "KIBUMBWE", population: 4448 },
            { id: "10609103", name: "GASEKANYA", population: 4690 },
            { id: "10609104", name: "MUGENDE", population: 6036 },
            { id: "10609105", name: "NYAKABUGU", population: 3049 }
          ]
        },
        {
          id: "10610",
          name: "MAYENZI",
          total: 27594,
          collines: [
            { id: "10610101", name: "GASENYI", population: 5133 },
            { id: "10610102", name: "RUYAGA", population: 4216 },
            { id: "10610103", name: "BURENZA", population: 2242 },
            { id: "10610104", name: "RUDARAZA", population: 3139 },
            { id: "10610105", name: "SHANGA", population: 3284 },
            { id: "10610106", name: "CIGATI", population: 2460 },
            { id: "10610107", name: "MAYENZI", population: 2972 },
            { id: "10610108", name: "RUTONGANIKWA", population: 2404 },
            { id: "10610109", name: "KARAMBA", population: 1744 }
          ]
        },
        {
          id: "10611",
          name: "MUBARAGAZA",
          total: 18155,
          collines: [
            { id: "10611101", name: "YAGIZO", population: 4578 },
            { id: "10611102", name: "SAGARA", population: 3835 },
            { id: "10611103", name: "MUBARAGAZA", population: 3262 },
            { id: "10611104", name: "KIGOMA", population: 3121 },
            { id: "10611105", name: "MUSENGA", population: 3359 }
          ]
        },
        {
          id: "10612",
          name: "MUHWEZA",
          total: 22499,
          collines: [
            { id: "10612101", name: "MUHWEZA", population: 4387 },
            { id: "10612102", name: "RUKAMBA", population: 5537 },
            { id: "10612103", name: "KARURI", population: 4120 },
            { id: "10612104", name: "BANDA", population: 2810 },
            { id: "10612105", name: "NYAMABEGA", population: 3378 },
            { id: "10612106", name: "KAJERI", population: 2267 }
          ]
        },
        {
          id: "10613",
          name: "MUTUMBA",
          total: 20245,
          collines: [
            { id: "10613101", name: "RWANGARA", population: 5120 },
            { id: "10613102", name: "RABIRO", population: 6106 },
            { id: "10613103", name: "BIBARA", population: 4251 },
            { id: "10613104", name: "KANYINYA", population: 4768 }
          ]
        },
        {
          id: "10614",
          name: "NTUNDA",
          total: 25155,
          collines: [
            { id: "10614101", name: "BIKINGA", population: 7633 },
            { id: "10614102", name: "BUGWANA", population: 6509 },
            { id: "10614103", name: "KIGOZI", population: 4422 },
            { id: "10614104", name: "NGAYANE", population: 3603 },
            { id: "10614105", name: "NTUNDA", population: 2988 }
          ]
        },
        {
          id: "10615",
          name: "NYAMUGARI",
          total: 10201,
          collines: [
            { id: "10615101", name: "Quartier KIGWATI", population: 4434 },
            { id: "10615102", name: "Quartier NYAMUGARI", population: 3422 },
            { id: "10615103", name: "Quartier KIGOMA", population: 1172 },
            { id: "10615104", name: "Quartier RUBIMBA", population: 1173 }
          ]
        },
        {
          id: "10616",
          name: "NYARUHINDA",
          total: 18884,
          collines: [
            { id: "10616101", name: "NYARUHINDA", population: 6721 },
            { id: "10616102", name: "RUHATA", population: 4241 },
            { id: "10616103", name: "GAHASHI", population: 2860 },
            { id: "10616104", name: "GAHAHE", population: 3221 },
            { id: "10616105", name: "GITANDU", population: 1841 }
          ]
        },
        {
          id: "10617",
          name: "RUGAZI",
          total: 21027,
          collines: [
            { id: "10617101", name: "TAMBI", population: 4847 },
            { id: "10617102", name: "RUGAZI", population: 3784 },
            { id: "10617103", name: "MUNYINYA", population: 3199 },
            { id: "10617104", name: "RUSENGO", population: 2193 },
            { id: "10617105", name: "MUBAYA", population: 1887 },
            { id: "10617106", name: "BONERO", population: 2710 },
            { id: "10617107", name: "BURENZA", population: 2407 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageGitegaKarusi = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(karusiData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = karusiData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info KARUSI
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {karusiData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de KARUSI`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de KARUSI
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE KARUSI</TableCell>
                          <TableCell align="right">{karusiData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de KARUSI
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de KARUSI est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de KARUSI ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
         
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageGitegaKarusi;